import { Card, CardContent, Typography } from "@material-ui/core";

export default function CuadreNotAvailable() {
  return (
    <Card
      variant="outlined"
      style={{
        margin: "80px auto",
        textAlign: "center",
        padding: 16,
      }}
    >
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Cuadre no está disponible
        </Typography>
        <Typography variant="body2" color="textSecondary">
          El cuadre no se puede ver, no está disponible en este momento.
        </Typography>
      </CardContent>
    </Card>
  );
}
